/**
 * Services reducer.
 * @module reducers/services
 */

import { POST_GOVBR_SERVICES } from '../constants/ActionTypes';

const defaultRequestState = {
  error: null,
  loaded: false,
  loading: false,
  firstLoad: true,
  data: {},
};

const initialState = {
  ...defaultRequestState,
  subrequests: {},
};

/**
 * services reducer.
 * @function services
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function services(state = initialState, action = {}) {
  switch (action.type) {
    case `${POST_GOVBR_SERVICES}_PENDING`:
      if (action.subrequest) {
        const previous =
          state.subrequests[action.subrequest] || defaultRequestState;
        return {
          ...state,
          firstLoad: false,
          subrequests: {
            ...state.subrequests,
            [action.subrequest]: {
              ...previous,
              error: null,
              loaded: false,
              loading: true,
              firstLoad: false,
            },
          },
        };
      }

      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        firstLoad: false,
      };
    case `${POST_GOVBR_SERVICES}_SUCCESS`:
      if (action.subrequest) {
        const previous =
          state.subrequests[action.subrequest] || defaultRequestState;
        const resultData = action.result || {};

        return {
          ...state,
          firstLoad: false,
          data: {
            ...state.data,
            ...resultData,
          },
          subrequests: {
            ...state.subrequests,
            [action.subrequest]: {
              ...previous,
              error: null,
              loaded: true,
              loading: false,
              firstLoad: false,
              data: resultData,
            },
          },
        };
      }

      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        firstLoad: false,
        data: action.result || {},
      };
    case `${POST_GOVBR_SERVICES}_FAIL`:
      if (action.subrequest) {
        const previous =
          state.subrequests[action.subrequest] || defaultRequestState;
        return {
          ...state,
          firstLoad: false,
          subrequests: {
            ...state.subrequests,
            [action.subrequest]: {
              ...previous,
              error: action.error,
              loaded: false,
              loading: false,
              firstLoad: false,
              data: {},
            },
          },
        };
      }

      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
        firstLoad: false,
        data: {},
      };
    default:
      return state;
  }
}
